// Table-of-contents scrolling for standard text pages. Unlike the blog
// (article-toc.js), which centres the target in the viewport, here we align
// the heading to the top of the page so the clicked section starts at the
// top. The top offset is provided by `scroll-margin-top` on the headings.
document.addEventListener('DOMContentLoaded', function () {
    const tocLinks = document.querySelectorAll('.page-toc .article-toc__list a');

    tocLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                e.preventDefault();
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.pushState(null, null, '#' + targetId);
            }
        });
    });
});
